<template>
  <div class="overflow-x-scroll flex-shrink-0 max-w-screen">
    <div class="px-3 border-b border-gray-300 min-w-max-content">
      <nav class="flex -mb-px">
        <router-link
          v-for="(entry, key) of tabs"
          :key="key"
          :to="`/${scope}/${key}/`"
          class="group block py-1.5 mx-2 text-sm font-medium leading-5 border-b-2 border-transparent transition duration-75 focus:outline-none"
          :class="selectedTab === key ? 'border-primary-700 text-primary-700' : 'text-gray-700 hover:text-gray-900'"
        >
          <div
            class="py-1.5 px-3 whitespace-nowrap rounded-lg transition duration-75"
            :class="selectedTab === key ? 'bg-gray-200' : 'group-hover:bg-gray-200'"
          >
            <i
              v-if="entry.icon"
              class="group-hover:opacity-100 transition duration-75 far fa-fw"
              :class="[entry.icon, selectedTab !== key && 'opacity-50']"
            />
            <span class="ml-2" v-text="entry.title" />
          </div>
        </router-link>
      </nav>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TabBar',
    props: {
      tabs: { type: Object, required: true }
    },
    computed: {
      selectedTab () {
        return this.$route.fullPath.split('/').filter(Boolean).pop()
      },
      scope () {
        return this.$route.fullPath.split('/').filter(Boolean).slice(0, -1).join('/')
      }
    }
  }
</script>
